import { Component, OnInit, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'app-magnifying-glass',
  templateUrl: './magnifying-glass.component.html',
  styleUrls: ['./magnifying-glass.component.scss']
})
export class MagnifyingGlassComponent implements OnInit {
  @Output() selectedVal: EventEmitter<number> = new EventEmitter();

  currentlySelected: string;
  currentlySelectedVal: number = 1;

  MAX: number = 3;
  MIN: number = 0.25;
  STEP: number = 0.25;
  predefinedNumbers: number[];
  constructor() { }

  castNumberToLabel(currentValue: number): string {
    const cv = currentValue * 100;
    return cv.toString() + '%';
  }

  ngOnInit(): void {
    this.predefinedNumbers = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 2.25, 2.5, 2.75, 3];
    this.setCurrentValue(1);
  }

  setCurrentValue(selectedVal: number): void{
    this.currentlySelectedVal = selectedVal;
    this.currentlySelected = this.castNumberToLabel(this.currentlySelectedVal);
    this.selectedVal.emit(selectedVal);
  }

  makeSmaller(): void {
    if (this.currentlySelectedVal > this.MIN) {
      this.setCurrentValue(this.currentlySelectedVal - this.STEP);
    }
  }

  makeBigger(): void {
    if (this.currentlySelectedVal < this.MAX) {
      this.setCurrentValue(this.currentlySelectedVal + this.STEP);
    }
  }


}
